import React from 'react';

import { useIntl } from 'react-intl';

import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useCreateAccessKey } from 'src/features/accessKey/api/useCreateAccessKey';
import { LIST_ACCESS_KEYS_RESOURCE } from 'src/features/accessKey/api/useListAccessKeys';
import { accessKeyMessages } from 'src/features/accessKey/utils/messages';
import AccessKeyFormModal from 'src/features/accessKey/components/form/AccessKeyFormModal';
import { useParking } from 'src/providers/ParkingProvider';

interface AccessKeyFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateAccessKeyFormModal<TData>({ className, semantics }: AccessKeyFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateAccessKey({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ACCESS_KEYS_RESOURCE] });
            toast({
                title: formatMessage(accessKeyMessages.createAccessKeySuccess),
                description: formatMessage(accessKeyMessages.createAccessKeySuccessDescription),
            });
        },
    });

    return (
        <AccessKeyFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(accessKeyMessages.createAccessKeyModalSubtitle)}
        />
    );
}

export default CreateAccessKeyFormModal;
